"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRoyaltyReductionForStakingAccount = exports.getRoyaltyReductionForUserAndMint = exports.getRegisteredCurrencyInfoFromPubkey = exports.getRegisteredCurrencyAccountInfo = exports.getMarketVarsAccountInfo = void 0;
const anchor_1 = require("@project-serum/anchor");
const pda_getters_1 = require("./pda_getters");
const getMarketplaceProgram_1 = require("./../utils/getMarketplaceProgram");
const atlas_staking_1 = require("../../atlas-staking");
/**
 * Returns the contents of the market vars account as detailed in the MarketVarsInfo interface
 *
 * @param connection
 * @param programId - Deployed program ID for Galactic Marketplace
 */
function getMarketVarsAccountInfo(connection, programId) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, getMarketplaceProgram_1.getMarketplaceProgram)({
            connection: connection,
            programId: programId,
        });
        const [marketVarsAccount] = yield (0, pda_getters_1.getMarketVarsAccount)(programId);
        const marketVarsInfo = yield program.account.marketVars.fetch(marketVarsAccount);
        return marketVarsInfo;
    });
}
exports.getMarketVarsAccountInfo = getMarketVarsAccountInfo;
/**
 * Returns the contents of a registered currency account as detailed in the RegisteredCurrencyInfo interface
 *
 * @param connection
 * @param programId - Deployed program ID for Galactic Marketplace
 * @param currencyMint - Mint address of currency
 */
function getRegisteredCurrencyAccountInfo(connection, programId, currencyMint) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, getMarketplaceProgram_1.getMarketplaceProgram)({
            connection: connection,
            programId: programId,
        });
        const [registeredCurrencyAccount] = yield (0, pda_getters_1.getRegisteredCurrencyAccount)(programId, currencyMint);
        const registeredCurrencyInfo = yield program.account.registeredCurrency.fetch(registeredCurrencyAccount);
        return registeredCurrencyInfo;
    });
}
exports.getRegisteredCurrencyAccountInfo = getRegisteredCurrencyAccountInfo;
/**
 * Retursn the contents of a registered currency info for a provided RegisteredCurrency pubkey
 *
 * @param connection
 * @param programId - Deployed program ID for Galactic Marketplace
 * @param registeredCurrency - Public key for a RegisteredCurrency
 * @returns
 */
function getRegisteredCurrencyInfoFromPubkey(connection, programId, registeredCurrency) {
    return __awaiter(this, void 0, void 0, function* () {
        const program = (0, getMarketplaceProgram_1.getMarketplaceProgram)({
            connection,
            programId,
        });
        const registeredCurrencyInfo = yield program.account.registeredCurrency.fetch(registeredCurrency);
        return registeredCurrencyInfo;
    });
}
exports.getRegisteredCurrencyInfoFromPubkey = getRegisteredCurrencyInfoFromPubkey;
function getRoyaltyReductionForUserAndMint(connection, gmProgramId, stakingProgramId, playerPubkey, registeredCurrency, registeredStake) {
    return __awaiter(this, void 0, void 0, function* () {
        let formattedDiscount = 0;
        // Find registered currency info
        const registeredCurrencyInfo = yield getRegisteredCurrencyInfoFromPubkey(connection, gmProgramId, registeredCurrency);
        // Find user's staking account
        const [stakingAccount] = yield (0, atlas_staking_1.getStakingAccount)(stakingProgramId, playerPubkey, registeredStake);
        const stakingAccountInfo = yield (0, atlas_staking_1.getStakingAccountInfo)(connection, stakingAccount, stakingProgramId);
        if (stakingAccountInfo.unstakedTs.eq(new anchor_1.BN(0))) {
            // Match user's total stake with the correct royalty tier
            const tiers = registeredCurrencyInfo.royaltyTiers;
            let discount = new anchor_1.BN(0);
            for (const tier of tiers) {
                if (stakingAccountInfo.totalStake.gte(tier.stakeAmount)) {
                    discount = tier.discount;
                }
            }
            // Format discount rate
            formattedDiscount = discount.toNumber() / 10000;
        }
        // Return discount rate
        return formattedDiscount;
    });
}
exports.getRoyaltyReductionForUserAndMint = getRoyaltyReductionForUserAndMint;
function getRoyaltyReductionForStakingAccount(connection, gmProgramId, stakingProgramId, stakingAccount, registeredCurrency) {
    return __awaiter(this, void 0, void 0, function* () {
        let formattedDiscount = 0;
        // Find registered currency info
        const registeredCurrencyInfo = yield getRegisteredCurrencyInfoFromPubkey(connection, gmProgramId, registeredCurrency);
        // Find user's atlas staking account info
        const stakingAccountInfo = yield (0, atlas_staking_1.getStakingAccountInfo)(connection, stakingAccount, stakingProgramId);
        if (stakingAccountInfo.unstakedTs.eq(new anchor_1.BN(0))) {
            // Match user's total stake with the correct royalty tier
            const tiers = registeredCurrencyInfo.royaltyTiers;
            let discount = new anchor_1.BN(0);
            for (const tier of tiers) {
                if (stakingAccountInfo.totalStake.gte(tier.stakeAmount)) {
                    discount = tier.discount;
                }
            }
            // Format discount rate
            formattedDiscount = discount.toNumber() / 10000;
        }
        // Return discount rate
        return formattedDiscount;
    });
}
exports.getRoyaltyReductionForStakingAccount = getRoyaltyReductionForStakingAccount;
//# sourceMappingURL=pda_info_getters.js.map